import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchFacetRefinementSelect } from '@uncinc/react-searchkit';

import { facetAttributes } from '../config';

export interface SearchAllContentAdvancedFacetsProps {
  className?: string;
}

const SearchAllContentAdvancedFacets: React.FC<SearchAllContentAdvancedFacetsProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  const classNames = c('SearchAllContent__AdvancedFacets', className);

  return (
    <div className={classNames}>
      <h2 className="asH3 mb-6">
        {t('components.search_general.facets.advanced_filters_title')}
      </h2>

      <div className="SearchAllContent__AdvancedFacets__facets">
        {/* We slice the first Facet ('type') because we render those as checkboxes. */}
        {facetAttributes.slice(1).map((facetAttribute) => {
          const attribute = typeof facetAttribute === 'object' ? facetAttribute.attribute : facetAttribute;

          return (
            <SearchFacetRefinementSelect
              key={attribute}
              attribute={attribute}
              // @ts-ignore @TODO RSK: Fix restProps typing
              title={t(`components.search_all_content.facets.${attribute}.title`)}
              placeholder={t(`components.search_all_content.facets.${attribute}.placeholder`)}
              searchable={attribute !== 'publication_year'}
              transformItems={(items) => items.map((item) => {
                let label = item.value;

                if (attribute === 'language') {
                  label = t(`langcodes:${item.value}`);
                }

                if (attribute === 'country_code') {
                  label = t(`countries:${item.value}`);
                }

                return {
                  ...item,
                  label,
                };
              })}
              {...(attribute === 'publication_year' && {
                sortBy: ['name:desc'],
              })}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SearchAllContentAdvancedFacets;
